export default __webpack_public_path__ + "static/devsecops-transformation-saas-compliance-2a65e9f41f999c60b5f02730bbe39b20.jpg";